import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkTheBus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1594 42.3396C17.1211 42.3396 18.7114 40.7493 18.7114 38.7876C18.7114 36.8259 17.1211 35.2356 15.1594 35.2356C13.1977 35.2356 11.6074 36.8259 11.6074 38.7876C11.6074 40.7493 13.1977 42.3396 15.1594 42.3396Z",
			fill: "#4BD2FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.7478 42.3396C48.7095 42.3396 50.2998 40.7493 50.2998 38.7876C50.2998 36.8259 48.7095 35.2356 46.7478 35.2356C44.7861 35.2356 43.1958 36.8259 43.1958 38.7876C43.1958 40.7493 44.7861 42.3396 46.7478 42.3396Z",
			fill: "#4BD2FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.1361 26.2498L52.9243 13.161C52.3672 7.14671 47.3214 2.54663 41.2813 2.54663H19.9678C13.7877 2.54663 8.62414 7.25367 8.05415 13.4079L6.86537 26.2498C6.84599 26.4594 6.83594 26.669 6.83594 26.8794V43.0744C6.83594 46.8454 9.89332 49.9028 13.6643 49.9028H47.3357C51.1067 49.9028 54.1641 46.8454 54.1641 43.0744V26.8794C54.1641 26.669 54.1547 26.4594 54.1346 26.2498H54.1361ZM14.8509 13.3376C14.9952 11.6886 16.3756 10.423 18.031 10.423H42.9697C44.6251 10.423 46.0062 11.6886 46.1498 13.3376L47.0644 23.8119H13.9363L14.8509 13.3376ZM15.2594 41.76C13.5458 41.76 12.1575 40.3709 12.1575 38.6581C12.1575 36.9453 13.5465 35.5562 15.2594 35.5562C16.9722 35.5562 18.3613 36.9453 18.3613 38.6581C18.3613 40.3709 16.9729 41.76 15.2594 41.76ZM46.503 42.2424C44.7895 42.2424 43.4011 40.8533 43.4011 39.1405C43.4011 37.4277 44.7902 36.0386 46.503 36.0386C48.2158 36.0386 49.6056 37.4277 49.6056 39.1405C49.6056 40.8533 48.2165 42.2424 46.503 42.2424Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1431 56.0306C12.1431 56.8166 12.7805 57.4534 13.5659 57.4534H17.0159C17.802 57.4534 18.4387 56.8159 18.4387 56.0306V51.1577H12.1431V56.0306Z",
			fill: "#4BD2FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.356 56.0306C43.356 56.8166 43.9927 57.4534 44.7788 57.4534H48.2288C49.0149 57.4534 49.6516 56.8159 49.6516 56.0306V51.1577H43.356V56.0306Z",
			fill: "#4BD2FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.9558 7.57617H17.0452C16.8803 7.57617 16.7466 7.70987 16.7466 7.8748V8.48642C16.7466 8.65135 16.8803 8.78505 17.0452 8.78505H43.9558C44.1207 8.78505 44.2544 8.65135 44.2544 8.48642V7.8748C44.2544 7.70987 44.1207 7.57617 43.9558 7.57617Z",
			fill: "#4BD2FE"
		})
	]
});
export default SvgParkTheBus;
